module.exports = __webpack_public_path__ + "static/avatar-99b41ee7bd4be7b3a4cb37deb03aa290.jpg";